"use client";

import dynamic from "next/dynamic";

const AdSwitcher = dynamic(() => import("@/components/Ads/DomainAdSwitcher"), {
  ssr: false,
});

const RichMedia = dynamic(
  () => import("@/components/Ads/AdComponent").then((mod) => mod.RichMedia),
  {
    ssr: false,
  },
);

import { ProsperBillboard } from "@/components/Ads/DomainAdSwitcher";

export function AdComponents() {
  return (
    <>
      <ProsperBillboard alias="home-layout-billboard" />
      <RichMedia />
    </>
  );
}
